import React, { Component } from "react";
import { Switch, Route, hashHistory } from "react-router-dom";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import PageWrapper from "shared/PageWrapper";
import SeasonWrapper from "components/SeasonWrapper";
import SeasonLabel from "components/SeasonLabel";
import SeasonContainer from "components/SeasonContainer";
import Season from "containers/Season";
import Link from "shared/Link";
import HashLink from "shared/HashLink";
import H1 from "shared/H1";

import Video from "components/Video";
import Flex from "shared/Flex";
import FlexItem from "shared/FlexItem";

class Collections extends Component {
  constructor(props) {
    super(props);
    const seasons = [
      "SS24",
      "SS23",
      "AW21",
      "SS21",
      "AW20",
      "SS20",
      "AW19",
      "SS19",
      "AW18",
      "SS18",
      "AW17",
      "SS17",
    ];
    const counts = [30, 28, 34, 33, 30, 30, 31, 25, 46, 22, 13, 12];
    this.state = {
      seasons,
      counts,
      keys: Array.from(Array(seasons.length).keys()),
      hash: "#" + seasons[0],
      activeSeason: seasons[0],
    };

    window.addEventListener("scroll", this.onScroll);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.location.hash !== newProps.location.hash) {
      let newSeason =
        (newProps.location.hash && newProps.location.hash.slice(1)) ||
        this.state.seasons[0];
      this.setState({
        hash: "#" + newSeason,
      });
    }
  }

  onScroll = () => {
    // console.log(this.state.hash);
    if (this.ref) {
      for (let season of this.state.seasons) {
        let elem = this.ref.querySelector("#" + season);
        let elFromTop = elem.offsetTop - window.pageYOffset;
        let elFromTopPlusHeight =
          elem.offsetTop + elem.offsetHeight - window.pageYOffset;
        let whenTopOfElementHitsMidWindow = elFromTop - window.innerHeight / 2;
        let whenBottomOfElementHitsMidWindow =
          elFromTopPlusHeight - window.innerHeight / 2;
        if (
          whenTopOfElementHitsMidWindow <= 0 &&
          whenBottomOfElementHitsMidWindow > 0 &&
          this.state.hash != "#" + season
        ) {
          // window.location.hash = "#" + season
          this.setState({
            hash: "#" + season,
          });
          return;
        }
      }
    }
  };

  setActiveSeason = (season) => {
    if (this.state.season !== season) {
      this.setState({
        activeSeason: season,
      });
    }
  };

  render() {
    return (
      <div ref={(ref) => (this.ref = ref)}>
        <Helmet>
          <title>Barragán Collections</title>
          <meta name="description" content="Barragán Collections" />
          <meta property="og:description" content="Barragán Collections" />
        </Helmet>
        {this.props.small && (
          <PageWrapper>
            <Flex
              fixed
              zIndex={15}
              wrap
              justifyContent="space-between"
              ref={(ref) => (this.linksRef = ref)}
            >
              {this.state.seasons.map((s) => (
                <HashLink
                  key={s}
                  active={this.state.hash === "#" + s ? 1 : null}
                  to={`/collections#${s}`}
                >
                  {s}
                </HashLink>
              ))}
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
              <div style={{ width: "40px", height: "0px" }}></div>
            </Flex>
            <Flex height="52px"></Flex>
          </PageWrapper>
        )}
        {this.state.keys.map((idx) => (
          <SeasonWrapper id={this.state.seasons[idx]} key={idx}>
            {!this.props.small && (
              <SeasonLabel>
                <Link to={`/collections/${this.state.seasons[idx]}`}>
                  {this.state.seasons[idx]}
                </Link>
              </SeasonLabel>
            )}

            <SeasonContainer>
              <Season
                small={this.props.small}
                season={this.state.seasons[idx]}
                count={this.state.counts[idx]}
                activeSeason={this.state.activeSeason}
                setActiveSeason={this.setActiveSeason}
                hideActive={this.state.hash != "#" + this.state.seasons[idx]}
              ></Season>
            </SeasonContainer>
          </SeasonWrapper>
        ))}
      </div>
    );
  }
}

export default Collections;



// WEBPACK FOOTER //
// ./src/containers/Collections.js